import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'cc-keypad',
  templateUrl: './keypad.component.html',
  styleUrls: ['./keypad.component.scss']
})
export class KeypadComponent implements OnInit {
  @Input() selectedKeys;
  @Output() characterClick: EventEmitter<string> = new EventEmitter();

  constructor() {}

  ngOnInit() {}

  handleCharacterClicked(character: string) {
    this.characterClick.emit(character);
  }

  isKeySelected(key: string) {
    return this.selectedKeys.has(key);
  }
}
